import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { Delete } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

export default function InvoiceMenu({ onDelete }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDelete = () => {
        onDelete();
        handleClose();
    };

    return (
        <Box>
            <IconButton
                size="small"
                onClick={handleClick}
                sx={{ padding: "2px" }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={handleDelete} sx={{ fontSize: 14 }}>
                    <Delete fontSize="small" sx={{ mr: 1 }} /> Delete Bill
                </MenuItem>
            </Menu>
        </Box>
    );
}
